import React from 'react';

import type { Role } from '../../../api/types';

import './RoleStatsBar.css';

export type RoleStats = {
  user: number;
  organizer: number;
  admin: number;
};

export type RoleStatsBarProps = {
  stats: RoleStats;
  activeFilter: Role | null;
  onFilterChange: (role: Role | null) => void;
};

type StatCardConfig = {
  role: Role;
  label: string;
  icon: string;
};

const statCards: StatCardConfig[] = [
  { role: 'user', label: 'Пользователи', icon: '🛡️' },
  { role: 'organizer', label: 'Организаторы', icon: '⚔️' },
  { role: 'admin', label: 'Админы', icon: '👑' },
];

export function RoleStatsBar({ stats, activeFilter, onFilterChange }: RoleStatsBarProps) {
  const handleClick = (role: Role) => {
    if (activeFilter === role) {
      onFilterChange(null);
    } else {
      onFilterChange(role);
    }
  };

  return (
    <div className="role-stats-bar">
      {statCards.map((card) => {
        const count = stats[card.role];
        const isActive = activeFilter === card.role;

        return (
          <button
            key={card.role}
            type="button"
            className={`role-stat-card ${isActive ? 'role-stat-card--active' : ''}`}
            onClick={() => handleClick(card.role)}
          >
            <div className="role-stat-icon">{card.icon}</div>
            <div className="role-stat-value">{count}</div>
            <div className="role-stat-label">{card.label}</div>
          </button>
        );
      })}
    </div>
  );
}
